module.exports = __webpack_public_path__ + "media/img/payment-methods/amex-0782be0bc7ee820c8efa911689392bc3.svg";